export enum CashMovementType {
    CASH_IN = 'cash in',
    CASH_OUT = 'cash out',
    STARTING_CASH = 'starting cash'
}